import { isChannel } from "utils";
import api from "../../../_config/http";

export async function sha256Hex(input) {
    const data = new TextEncoder().encode(input);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function changeLocationDepartureAction(location) {
    return {
        type: 'SEARCH_LOCATION_DEPARTURE_AIRFARE',
        payload: {
            locationDeparture: location
        }
    }
}

export function changeLocationArrivalAction(location) {
    return {
        type: 'SEARCH_LOCATION_ARRIVAL_AIRFARE',
        payload: {
            locationArrival: location
        }
    }
}

export function changeOnlyDepartureAction(boolean) {
    return {
        type: 'SEARCH_ONLY_DEPARTURE_AIRFARE',
        payload: {
            onlyDeparture: boolean
        }
    }
}

export function changeDatesAirfareAction(dates) {
    return {
        type: 'SEARCH_DATES_AIRFARE',
        payload: {
            datesSearchAirfare: dates
        }
    }
}

export const changeOfferAirfareAction = (data) => {
    return {
        type: 'SEARCH_OFFER_AIRFARE',
        payload: {
            offersAirfare: data
        }
    }
}

export const changePassengersAirfareAction = (data) => {
    return {
        type: 'SEARCH_PASSENGERS_AIRFARE',
        payload: {
            numberOfPassengers: data
        }
    }
}

export const changeClassAirfareAction = (data) => {
    return {
        type: 'SEARCH_CLASS_AIRFARE',
        payload: {
            classAirfare: data
        }
    }
}

export const checkoutAirfareAction = async (props) => {
    const { customerId, flight, travellers, payment, installmentSelected, offersAirfare } = props;
    const customer = JSON.parse(localStorage.getItem("customer_envision_v1") || "{}");

    const formatTravellers = travellers.map(item => {
        const [day, month, year] = item.birthDate.split('/');
        const birthDate = year + '-' + month + '-' + day;
        const identification = item.document?.replaceAll('.', '').replace('-', '');

        return {
            "FirstName": item.firstName,
            "MiddleName": "",
            "LastName": item.lastName,
            "BirthDate": birthDate,
            "Gender": item.gender === 'male' ? 'Male' : 'Female',
            "Type": item.type || 'ADT', // ADT, CHD, INF
            "Identification": identification,
            "IdType": item.idType || "CPF",
            "Nationality": item.nationality || "BR"
        }
    });

    const checkoutData = {
        "customerId": customerId,
        "contactInformations": customer,
        "payment_type": offersAirfare,
        "fromChannel": isChannel('safra') ? 'safra' : 'll',
        "travellers": formatTravellers,
        "flight": flight.raw // The raw recommendation from API
    };

    if (isChannel('safra')) {
        const data = JSON.stringify(checkoutData);
        const salt = "z{*'";
        const hash = await sha256Hex(data + salt);
        localStorage.setItem("order_data", hash);
        return data;
    } else {
        checkoutData.payment = payment; // Handle credit card for other channels if needed
        return api.post('/flights/order', JSON.stringify(checkoutData));
    }
}

export const setSearchIdAction = (searchId) => {
    return {
        type: 'SET_SEARCH_ID',
        payload: { searchId }
    }
}

export const setChooseIdAction = (chooseId) => {
    return {
        type: 'SET_CHOOSE_ID',
        payload: { chooseId }
    }
}

export const setChooseDataAction = (chooseData) => {
    return {
        type: 'SET_CHOOSE_DATA',
        payload: { chooseData }
    }
}
